import { ResultBuilder } from "appworks/server/builders/result-builder";
import { contains, lastInArray } from "appworks/utils/collection-utils";
import { GMRAction } from "gaming-realms/integration/gmr-schema";
import { SlingoResponse, SlingoStakeToSpinConfig } from "slingo/integration/slingo-schema";
import { SlingoRecord } from "slingo/model/records/slingo-record";
import { SlingoStakeToSpinResult } from "slingo/model/results/slingo-stake-to-spin-result";
import { slingoModel } from "slingo/model/slingo-model";

export class SlingoStakeToSpinResultBuilder implements ResultBuilder {
    protected lastStakeToSpinData: SlingoStakeToSpinConfig;

    public filter(data: SlingoResponse, record?: SlingoRecord): boolean {
        const hasNextStake = Boolean(data.spinResult?.nextStakeToSpin || data.spinResult?.stakeToSpin);
        const isNotCompleteWithPurchase = !(
            data.state === "COMPLETE" &&
            contains(data.actions, GMRAction.PURCHASE) &&
            !contains(["MAXIMUM_TOTAL_STAKE_LIMIT", "MAXIMUM_STAKE_LIMIT"], data.gameProgress.completionReason)
        );

        return hasNextStake && isNotCompleteWithPurchase;
    }

    public build(record: SlingoRecord, data: SlingoResponse): SlingoStakeToSpinResult[] {
        const stakeToSpinData = lastInArray(data.spinResult.nextStakeToSpin) ?? data.spinResult.stakeToSpin;
        if (this.compareStakeToSpinData(stakeToSpinData)) return [];
        this.lastStakeToSpinData = stakeToSpinData;

        const result = new SlingoStakeToSpinResult();

        result.rng = stakeToSpinData.feature.rng;

        record.wager = Math.round(stakeToSpinData.stake * 100);

        if (slingoModel.read().gameConfig.maximumStakeToSpinAttempts > 0) {
            if (data?.spinResult?.nextStakeToSpin) {
                result.spinsRemaining = slingoModel.read().gameConfig.maximumStakeToSpinAttempts - data.spinResult.nextStakeToSpin.length;
            }
        }

        return [result];
    }

    /**
     * GMR send us the same stake to spin data repeatedly, i.e. if you have a successful super spin which leads to a pick,
     * the pick response will contain the same data, so we were incorrectly counting the wager again
     */
    protected compareStakeToSpinData(data: SlingoStakeToSpinConfig): boolean {
        if (!this.lastStakeToSpinData) return false;

        return (
            data.feature.rng.bound === this.lastStakeToSpinData.feature.rng.bound &&
            data.feature.rng.result === this.lastStakeToSpinData.feature.rng.result &&
            data.feature.rng.weight === this.lastStakeToSpinData.feature.rng.weight &&
            data.win === this.lastStakeToSpinData.win
        );
    }
}
